<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Modifier Utilisateur
            </strong>
          </div>
          <b-form>
            <b-row>
              <b-col sm="4">
                <b-form-group label="Nom" label-for="basicName">
                  <b-form-input
                    id="basicName"
                    type="text"
                    autocomplete="name"
                    :class="{hasError: errors.nom !== ''}"
                    v-model="nom"
                  ></b-form-input>
                  <span class="field-error">{{ errors.nom }}</span>
                </b-form-group>

                <b-form-group label="Prénom" label-for="basicPrenom">
                  <b-form-input
                    id="basicPrenom"
                    type="text"
                    placeholder="Text"
                    :class="{hasError: errors.prenom !== ''}"
                    v-model="prenom"
                  ></b-form-input>
                  <span class="field-error">{{ errors.prenom }}</span>
                </b-form-group>

                <b-form-group label="Email" label-for="basicEmail">
                  <b-form-input
                    id="basicEmail"
                    type="email"
                    placeholder="Enter your email"
                    autocomplete="email"
                    :class="{hasError: errors.email !== ''}"
                    v-model="email"
                  ></b-form-input>
                  <span class="field-error">{{ errors.email }}</span>
                  <span class="field-error">{{ validationErrors.email }}</span>
                </b-form-group>
                <b-form-group label="Structure" label-for="basicSelect">
                      <b-form-select
                          id="basicSelectStructure"
                          :plain="true"
                          :options="structuresOptions"
                          v-model="selectedStructure"
                      />
                      </b-form-group>
                      <span class="field-error">{{ errors.structure }}</span>
                </b-form-group>

                <b-row>
                  <b-col sm="6">
                    <b-form-group label="N° User NSI" label-for="basicUserNSI">
                        <b-form-input
                            id="basicUserNSI"
                            type="text"
                            placeholder=""
                            :class="{hasError: errors.nsi_numero_user !== ''}"
                            v-model="nsi_numero_user"
                        ></b-form-input>
                        <span class="field-error">{{ errors.nsi_numero_user }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group label="N° Acteur NSI" label-for="basicActeurNSI">
                        <b-form-input
                            id="basicActeurNSI"
                            type="text"
                            placeholder=""
                            :class="{hasError: errors.nsi_numero_acteur !== ''}"
                            v-model="nsi_numero_acteur"
                        ></b-form-input>
                        <span class="field-error">{{ errors.nsi_numero_acteur }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="8">
                <div class="customRow">
                    <div style="margin-bottom:-6px;">
                      <strong>Date de dernière connexion :</strong> {{ formatDate(date_connexion) }}
                      <b-badge v-if="!gestionnaire.is_locked" class="ml-2" variant="success">OK</b-badge>
                      <b-badge v-else class="ml-2" variant="danger">Bloqué</b-badge><i v-if="gestionnaire.is_locked" class="fa fa-unlock clickable ml-2 text-success" title="Débloquer" @click="debloquer"></i>
                    </div>
                </div>
                <div class="customRow" v-if="profilActive && profilActive.date_fin === null">
                  <b-button type="button" v-b-modal.modal-ajout-profil size="md" class="pull-right" variant="secondary" disabled>
                    <i class="fa fa-plus"></i> Ajouter un profil
                  </b-button>
                  <span id="profil_actif-tooltip" class="pull-right"><i class="fa fa-question-circle orange-question orange-question-profil"></i></span>
                  <b-tooltip target="profil_actif-tooltip" triggers="hover" placement="top">Pour l'ajout d'un nouveau profil, il faut indiquer une date de fin du profil en cours</b-tooltip>
                </div>
                <div class="customRow" v-else>
                  <b-button type="button" v-b-modal.modal-ajout-profil size="md" class="pull-right" variant="success">
                    <i class="fa fa-plus"></i> Ajouter un profil
                  </b-button>
                </div>
                <div v-if="hasOldProfils()" id="old-profil">
                  <b-card header-tag="header">
                    <template v-slot:header>

                      <b-link class="card-header-action btn-minimize full-width like-header" v-b-toggle.collapse1>
                        <strong> Ancien(s) profil(s)</strong>
                          <span class="when-opened pull-right">
                            <i class="icon-arrow-down"></i>
                          </span>
                          <span class="when-closed pull-right">
                            <span id="old_profils-tooltip"><i class="icon-arrow-up"></i></span>
                          </span>
                        <b-tooltip target="old_profils-tooltip" placement="top">Voir les anciens profils.</b-tooltip>
                      </b-link>
                    </template>
                    <b-card-text>
                      <b-collapse id="collapse1" style="margin-top:20px">
                        <b-row style="padding: 0 10px 0 10px">
                          <b-col sm="12">
                            <ul>
                              <li v-for="oldProfil in oldProfils">{{ oldProfil.libelle }} du {{ oldProfil.date_debut | formatDate }} au {{ oldProfil.date_fin | formatDate }}</li>
                            </ul>
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </b-card-text>
                  </b-card>
                </div>
                <div v-if="!hasActiveProfils()">Pas de profil actif</div>
                <div v-else>
                  <div slot="header">
                    <strong> Profil actif</strong>
                    <v-client-table :columns="columns" :data="profilActive" :options="options" class="profil-actif">
                      <div slot="date_debut" slot-scope="props">
                        <b-form-input type="date" v-model="dateDebutProfil[props.row.pivot_id]"></b-form-input>
                        <span class="field-error">{{ errors.dateDebutProfil[props.row.pivot_id] }}</span>
                      </div>
                      <div slot="date_fin" slot-scope="props">
                        <b-form-input type="date" v-model="dateFinProfil[props.row.pivot_id]"></b-form-input>
                        <span class="field-error">{{ errors.dateFinProfil[props.row.pivot_id] }}</span>
                      </div>
                      <div slot="action" slot-scope="props">
                        <b-button class="button-action" type="button" @click.prevent="showDroit(props.row.id)" size="md" variant="primary" title="Voir les droits du profil">
                          <i class="fa fa-eye"></i>
                        </b-button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
                <div v-if="hasFuturProfils()">
                  <hr>
                  <div slot="header">
                    <strong> Prochain(s) profil(s)</strong>
                    <v-client-table :columns="columns" :data="futurProfils" :options="options">
                      <div slot="date_debut" slot-scope="props">
                        <b-form-input type="date" v-model="dateDebutProfil[props.row.pivot_id]"></b-form-input>
                        <span class="field-error">{{ errors.dateDebutProfil[props.row.pivot_id] }}</span>
                      </div>
                      <div slot="date_fin" slot-scope="props">
                        <b-form-input type="date" v-model="dateFinProfil[props.row.pivot_id]"></b-form-input>
                        <span class="field-error">{{ errors.dateFinProfil[props.row.pivot_id] }}</span>
                      </div>
                      <div slot="action" slot-scope="props">
                        <b-button class="button-action" type="button" @click.prevent="showDroit(props.row.id)" size="md" variant="primary" title="Voir les droits du profil">
                          <i class="fa fa-eye"></i>
                        </b-button>
                        <b-button class="button-action" type="button" @click.prevent="removeProfil(props.row)" size="md" variant="danger" title="Supprimer le profil">
                          <i class="fa fa-close"></i>
                        </b-button>
                      </div>
                    </v-client-table>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <div slot="footer">
                  <b-button class="float-left" variant="warning" @click="returnBack"><i
                    class="fa fa-window-close"></i> Fermer sans enregistrer
                  </b-button>
                  <b-button type="button" @click="saveUser('close')" size="md" class="pull-left" style="margin-left: 20px;" variant="primary">
                    <i class="fa fa-save"></i> Enregistrer et Fermer
                  </b-button>
                  <b-button type="button" @click="saveUser('stay')" size="md" style="margin-left: 20px;" variant="primary">
                    <i class="fa fa-save"></i> Enregistrer
                  </b-button>
                  <b-button type="button" @click="destroy" size="md" style="margin-left: 40px;" variant="danger">
                    <i class="fa fa-remove"></i> Désactiver
                </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal ref="modal-droit" size="xl" @hide="resetDroits" ok-only title="Liste des droits du profil">
        <b-row>
          <b-alert show variant="warning" v-if="noRules">
            {{ noRules }}
          </b-alert>
          <b-form-group style="width:100%;">
            <b-form-checkbox-group v-model="checkedDroits">
              <b-row>
                <b-col sm="4" v-for="(group, key) in groups" :key="key">
                  <b-card header-tag="header" class="mb-1">
                    <h6 slot="header">
                      <span>{{ group.parent ? group.parent.text : "" }}</span>
                    </h6>
                    <div>
                      <li
                        v-for="droit in group.children"
                        :key="droit.value"
                      >{{ droit.text ? droit.text : "" }}</li>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-form-checkbox-group>
          </b-form-group>
        </b-row>
      </b-modal>
    </div>
    <div>
      <b-modal id="modal-ajout-profil" ref="modal-ajout-profil" @hide="cancel" size="lg" title="Ajouter un profil à l'utilisateur">
        <b-form-group label="Profil" label-for="basicSelectProfil">
          <b-form-select
            id="basicSelectProfil"
            :plain="true"
            :options="profilsOptions"
            v-model="selectedProfil"
            >
          </b-form-select>
          <span class="field-error">{{ errors.selectedProfil }}</span>
        </b-form-group>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="date_debut"><strong>Date début</strong></label>
              <b-form-input type="date" id="date_debut" v-model="dateDebut"></b-form-input>
                <span class="field-error">{{ errors.dateDebut }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="date_fin"><strong>Date fin</strong></label>
              <b-form-input type="date" id="date_fin" v-model="dateFin"></b-form-input>
                <span class="field-error">{{ errors.dateFin }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button type="button" @click="addProfil()" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Ajouter
            </b-button>
            <b-button type="button" @click="cancel" size="md" class="pull-right" style="margin-right:10px">
              Annuler
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "@/utils/auth"
import {en, fr} from 'vuejs-datepicker/dist/locale';
import {isEmpty} from "@/utils/fileHelper";

export default {
  data() {
    return {
      columns: ["libelle", "date_debut", "date_fin", "action"],
      options: {
        headings: {
          libelle: "Profil",
          date_debut: "Date début",
          date_fin: "Date fin",
        },
        filterable: false,
        columnsClasses: {
          action: "action-sm"
        },
        sortable: ["date_debut"],
      },
      nom: "",
      prenom: "",
      email: "",
      structure: "",
      structuresOptions: [],
      selectedStructure: "",
      profilActive: [],
      oldProfils: "",
      futurProfils: "",
      profils: [],
      profilsOptions: [],
      profilsId: [],
      selectedProfil: "",
      nsi_numero_user: "",
      nsi_numero_acteur: "",
      currentDroits: [],
      checkedDroits: [],
      date_connexion: '',
      connexion: '',
      errors: {
        nom: "",
        prenom: "",
        email: "",
        structure: "",
        nsi_numero_user: "",
        nsi_numero_acteur: "",
        selectedProfil: "",
        dateDebut: "",
        dateFin: "",
        dateDebutProfil: [],
        dateFinProfil: [],
      },
      dateDebut: "",
      dateFin: "",
      dateDebutProfil: {},
      dateFinProfil: {},
      validationErrors: {
        email: ""
      },
      noRules: '',
      fr: fr,
      DatePickerFormat: 'dd/MM/yyyy',
      gestionnaire: {},
    };
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] =
      getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    this.allHabilitations();
    this.getStructures();


    if (this.$route.params.id) {
      this.populateUser();
    }
  },
  watch: {
    selectedStructure: function() {
      if (this.selectedStructure) {
        // Si la structure change on vide le profil précédemment sélectionné et on recalcul le select des profils
        this.selectedProfil = '';
        this.setProfilOptions();
      } else {
        this.profilsOptions = [];
        this.selectedProfil = '';
      }
    },
    profils() {
      this.setProfilOptions();
    }
  },
  computed: {
    groups() {
      let droitTree = _.groupBy(this.currentDroits, "domaine");
      droitTree = _.map(droitTree, function(droitGroup) {
        // get parent
        let parent = _.find(droitGroup, function(droit) {
          if (droit.domaine == droit.category) return droit.value;
          //return droit.value.startsWith("can_access");
        });
        // get children
        let children = _.filter(droitGroup, function(droit) {
          if (droit.domaine != droit.category) return droit.value;
          //return !droit.value.startsWith("can_access");
        });
        return {
          parent: parent,
          children: children
        };
      });
      return droitTree;
    }
  },
  filters: {
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "";
      return date
    }
  },
  methods: {
    allHabilitations() {
      // Récupérer la liste de tous les profils
      this.$axios
        .get("/administration/profiles")
        .then(response => {
          this.profils = response.data.profils;

          // for (var i = 0; i < profils.length; i++) {
          //   this.profilsOptions.push({
          //     text: profils[i].libelle,
          //     value: profils[i].id
          //   });
          // }
        })
        .catch(function(error) {});
    },
    buildCurrentDroits() {
      let that = this;
      _.forEach(this.currentDroits, function(droit) {
        if (false) {
          that.checkedDroits.push(droit.value);
        }
      });
    },
    populateUser() {
      this.$store.commit("IS_LOADING", true);
      let userId = this.$route.params.id;
      let self = this;

      this.$axios
        .get("/administration/users/edit/" + userId)
        .then(response => {
          this.gestionnaire = response.data.user;
          this.profilsId = [];
          this.nom = response.data.user.nom;
          this.prenom = response.data.user.prenom;
          this.email = response.data.user.email;
          this.selectedStructure = response.data.user.structure_id;
          this.nsi_numero_user = response.data.user.nsi_numero_user;
          this.nsi_numero_acteur = response.data.user.nsi_numero_acteur;
          this.profilActive = [];
          if (response.data.user.profil_active[0]) {
            this.profilActive.push({id: response.data.user.profil_active[0].id, libelle: response.data.user.profil_active[0].libelle, date_debut: response.data.user.profil_active[0].pivot.date_debut, date_fin: response.data.user.profil_active[0].pivot.date_fin, pivot_id: response.data.user.profil_active[0].pivot.id});
          }

          this.oldProfils = response.data.user.old_profils.length > 0 ? response.data.user.old_profils : ""
          this.futurProfils = response.data.user.futur_profils.length > 0 ? response.data.user.futur_profils : ""

          this.profil = this.profilActive

          this.dateDebutProfil = {};
          this.dateFinProfil = {};
          if (response.data.user.profil_active[0]) {
            this.profilsId.push({profilId: response.data.user.profil_active[0].id, pivotId: response.data.user.profil_active[0].pivot.id})
            this.dateDebutProfil[response.data.user.profil_active[0].pivot.id] = response.data.user.profil_active[0].pivot.date_debut
            this.dateFinProfil[response.data.user.profil_active[0].pivot.id] = response.data.user.profil_active[0].pivot.date_fin
          }

          if (response.data.user.futur_profils.length > 0) {
            for(let futureProfil of response.data.user.futur_profils) {
              this.profilsId.push({profilId: futureProfil.id, pivotId: futureProfil.pivot_id})
              this.dateDebutProfil[futureProfil.pivot_id] = futureProfil.date_debut
              this.dateFinProfil[futureProfil.pivot_id] = futureProfil.date_fin
            }
          }
          this.date_connexion = response.data.user.date_connexion
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          if (
            error.response &&
            error.response.status === 404 &&
            self != undefined
          ) {
            self.$router.push({ path: "/administration/users" });
            self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: "l'utilisateur avec l'id " + id + " n'existe pas",
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
    },
    setProfilOptions() {
      this.profilsOptions = [];
      for (let profil of this.profils) {
        if (profil.structures.map(structure => structure.id).indexOf(this.selectedStructure) > -1) {
          this.profilsOptions.push({value: profil.id, text: profil.libelle});
        }
      }
    },
    hasOldProfils() {
      return !isEmpty(this.oldProfils);
    },
    hasFuturProfils() {
      return !isEmpty(this.futurProfils);
    },
    hasActiveProfils() {
      return !isEmpty(this.profil);
    },
    showDroit(profilId) {
      let self = this
      this.$store.commit('IS_LOADING', true)

      this.$axios
        .get('/administration/profile/rules/' + profilId)
        .then(response => {
          this.$store.commit('IS_LOADING', false)

          // On génère l'objet route avec resolve afin de générer l'URL
          const routeData = this.$router.resolve({
            path: "/administration/profiles/edit/" + profilId
          });

          // On ouvre dans un nouvel onglet
          window.open(routeData.href, '_blank');

          // On ferme la modal des droits
          this.$refs['modal-droit'].hide();
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    addProfil() {
      if (this.validateAddProfilData()) {
        let self = this;
        let userId = this.$route.params.id;
        let dataPost = {};

        dataPost.profil = this.selectedProfil;
        dataPost.dateDebut = this.dateDebut
        dataPost.dateFin = this.dateFin
        // On enregistre les données possiblement modifiée avant
        this.saveUser('stay').then(data => {
          if (data === 'ok') {
            this.$store.commit("IS_LOADING", true);
            this.$axios
            .post("/administration/users/profil/" + userId, dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Profil ajouté avec succès",
                text: "",
                showConfirmButton: false,
                timer: 3000
              });
              this.cancel()
              this.populateUser()
            })
            .catch(function(error) {
              self.$store.commit("IS_LOADING", false);
              if (error.response.status === 403) {
                self.$swal({
                  position: "top",
                  type: "warning",
                  title: "Attention !!",
                  text: "Vous ne pouvez pas attribuer ce profil à un utilisateur de cette structure",
                  showConfirmButton: false,
                  timer: 0
                });
              } else {
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }

            });
          } else {
            console.log(data)
          }
        })
        .catch( error => {
          console.log(error)
        });
      }
    },
    removeProfil(profil) {
      let userId = this.$route.params.id
      let dataPost = {}
      let self = this
      dataPost.pivotId = profil.pivot_id

      this.$axios
          .post("/administration/users/profil/delete/" + userId, dataPost)
          .then(response => {
            let profilConcerned = this.profils.filter((option) => {
              return option.id === profil.id
            })
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Suppression avec succès",
              text: "Le profil " + profilConcerned.text + " a bien été supprimé",
              showConfirmButton: false,
              timer: 5000
            });
            this.cancel()
            this.populateUser()
          })
          .catch(function(error) {
            console.log(error)
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un problème est survenu pendant la suppression du profil, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
    },
    cancel() {
      this.clearErrors()
      this.selectedProfil = ""
      this.dateDebut = ""
      this.dateFin = ""
      this.$refs['modal-ajout-profil'].hide()
    },
    resetDroits() {
      this.currentDroits = []
      this.noRules = ''
    },
    saveUser(type) {
      return new Promise((resolve, reject) => {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let self = this;
          let userId = this.$route.params.id;
          let dataPost = {};

          dataPost.nom = this.nom;
          dataPost.prenom = this.prenom;
          dataPost.email = this.email;
          dataPost.structure_id = this.selectedStructure;
          dataPost.nsi_numero_acteur = this.nsi_numero_acteur;
          dataPost.nsi_numero_user = this.nsi_numero_user;
          dataPost.dateDebutProfil = this.dateDebutProfil
          dataPost.dateFinProfil = this.dateFinProfil

          this.$axios
            .put("/administration/users/" + userId, dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "L'utilisateur " + dataPost.nom + ' ' + dataPost.prenom + " a bien été modifié",
                showConfirmButton: false,
                timer: 5000
              });
              if(type == 'close'){
                this.returnBack()
              }else{
                this.populateUser();
              }
              resolve('ok');
            })
            .catch(function(error) {
              self.$store.commit("IS_LOADING", false);
              if (error.response.status == 422 && error.response.data.errors){
                //self.validationErrors = error.response.data.errors.email;
                self.validationErrors.email = "Cette adresse email est déjà utilisée.";
              } else {
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }
              // throw new Error('Axios error saving user');
              // reject(new Error('Axios error saving user'));
              // reject();
            });
        } else {
          // throw new Error('No validate data');
          // reject(new Error('No validate data'));
          resolve('No validate data');
        }
      });

    },
    destroy() {
      let self = this;
      let userId = this.$route.params.id;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment désactiver cet utilisateur ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Désactiver"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true);
            this.$axios
              .post("/administration/users/desactivate/" + userId)
              .then(response => {
                this.$store.commit("IS_LOADING", false);
                this.$swal({
                  position: "top",
                  type: "success",
                  title: "Désactivation avec succès",
                  text: "L'utilisateur a bien été désactivé",
                  showConfirmButton: false,
                  timer: 5000
                });
                this.returnBack()
              })
              .catch(function(error) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          }
        });
    },
    returnBack() {
      this.$router.push({ path: "/administration/users", query: { inc: this.$route.query.inc, fil: this.$route.query.fil, no: this.$route.query.no, pre: this.$route.query.pre, em: this.$route.query.em, pro: this.$route.query.pro, st: this.$route.query.st }});
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "";
      return date;
    },
    validateAddProfilData() {
      // console.log('this.dateFinProfil',this.dateFinProfil)
      this.clearErrors()
      let dateFrom = new Date(this.dateDebut)
      let dateTo = new Date(this.dateFin)
      let valid = true

      if (this.selectedProfil === "") {
        this.errors.selectedProfil = "Vous devez sélectionner un profil"
        valid = false;
      }
      // vérifiaction des dates pour l'ajout d'un profil
      if (this.dateFinProfil[this.profilActive.pivot_id] === "") {
        this.errors.dateDebut = "Vous devez d'abord renseigner une date de fin pour le profil actif avant de pouvoir en ajouter un autre"
        valid = false;
      } else {
        if (this.dateDebut === "") {
          this.errors.dateDebut = "La date de début est obligatoire"
          valid= false;
        } else {
          if (this.dateFin !== null && this.dateFin !== "") {
            if (dateTo.getTime() < dateFrom.getTime()) {
              this.errors.dateFin = "La date de fin doit être postérieure à la date de début"
              valid= false;
            }
          } else {
            let nbDateFinVide = 0;
            Object.keys(this.dateFinProfil).forEach( key => {
              if (isEmpty(this.dateFinProfil[key])) {
                nbDateFinVide++;
              }
            });
            // let profilsDateFinVide = this.dateFinProfil.filter((dateFin) => {
            //   return (dateFin === "" || dateFin === null)
            // })
            if (nbDateFinVide > 1) {
              this.errors.dateFin = "Il ne peut y avoir plus d'une date de fin non renseignée"
              valid= false;
            }
          }
          let dateToProfilActive = new Date(this.dateFinProfil[this.profilActive.pivot_id])
          if (dateFrom.getTime() <= dateToProfilActive.getTime()) {
            this.errors.dateDebut = "La date de début du profil ne peut être inférieur à la date de fin du profil actif";
            valid = false;
          }
        }
      }
      if (valid) {
        for(let profilId2 of this.profilsId) {
          let profilConcerned = this.profils.filter((option) => {
            return option.id === profilId2.profilId;
          })
          // console.log(profilConcerned)
          if (this.dateFinProfil[profilId2.pivotId] === "" || this.dateFinProfil[profilId2.pivotId] === null) {
            // cas : profil_1 du 01-01-2020 au null
            //       profil_2 du 05-01-2020 au 07-01-2020
            if (this.dateDebut >= this.dateDebutProfil[profilId2.pivotId]) {
              this.errors.dateDebut = "Il faut donner une date de fin au profil " + profilConcerned[0].text + " avant de pouvoir ajouter un profil postérieur"
              valid= false
            }
            // cas : profil_1 du 01-02-2020 au null
            //       profil_2 du 05-01-2020 au 07-05-2020
            if (this.dateFin >= this.dateDebutProfil[profilId2.pivotId] && this.dateDebut < this.dateDebutProfil[profilId2.pivotId]) {
              this.errors.dateFin = "La date de fin entre en conflit avec le profil " + profilConcerned[0].text
              valid= false
            }

          } else {
            // cas : profil_1 du 01-01-2020 au 01-02-2020
            //       profil_2 du 05-01-2020 au 07-02-2020
            if (this.dateDebut >= this.dateDebutProfil[profilId2.pivotId] && this.dateDebut <= this.dateFinProfil[profilId2.pivotId]) {
              this.errors.dateDebut = "La date de début entre en conflit avec le profil " + profilConcerned[0].text
              valid= false
            }
            // cas : profil_1 du 01-01-2020 au 01-02-2020
            //       profil_2 du 05-12-2019 au 07-01-2020
            if (this.dateFin >= this.dateDebutProfil[profilId2.pivotId] && this.dateFin <= this.dateFinProfil[profilId2.pivotId]) {
              this.errors.dateFin = "La date de fin entre en conflit avec le profil " + profilConcerned[0].text
              valid= false
            }
          }
        }
      }
      return valid
    },
    validateData() {
      this.clearErrors();
      let regEmail = this.$store.getters.getRegMail;
      let regAlpha = this.$store.getters.getRegAlpha;
      let valid = true;

      if (this.nom === "") {
        this.errors.nom = "Le nom est obligatoire";
        valid = false;
      } else if (!regAlpha.test(this.nom.trim())) {
        valid = false;
        this.errors.nom = "Veuillez entrer un nom valide";
      }
      if (this.prenom === "") {
        this.errors.prenom = "Le prénom est obligatoire";
        valid = false;
      } else if (!regAlpha.test(this.prenom.trim())) {
        valid = false;
        this.errors.prenom = "Veuillez entrer un prénom valide";
      }
      if (this.email === "") {
        this.errors.email = "L'adresse email est obligatoire";
        valid = false;
      } else if (!regEmail.test(this.email.trim())) {
        valid = false;
        this.errors.email = "Veuillez entrer une adresse mail valide";
      }
      if (this.selectedStructure === "") {
        this.errors.structure = "La structure est obligatoire";
        valid = false;
      }

      // Vérification cohérence des dates pour profils
      if (this.profilsId.length > 0) {
        for(let profilId of this.profilsId) {
          if (this.dateDebutProfil[profilId.pivotId] === "") {
            this.errors.dateDebutProfil[profilId.pivotId] = "La date de début est obligatoire";
            valid = false;
          } else {
            let dateFromProfil = new Date(this.dateDebutProfil[profilId.pivotId])
            if (profilId.pivotId === this.profilActive.pivot_id && this.dateFinProfil[profilId.pivotId] === "" && this.profilsId.length > 1) {
              this.errors.dateFinProfil[profilId.pivotId] = "La date de fin est obligatoire si d'autres profils à venir sont présents";
              valid = false;
            } else if (this.dateFinProfil[profilId.pivotId] !== "" && this.dateFinProfil[profilId.pivotId] !== null) {
              let dateToProfil = new Date(this.dateFinProfil[profilId.pivotId])
              if (dateToProfil.getTime() < dateFromProfil.getTime()) {
                this.errors.dateFinProfil[profilId.pivotId] = "La date de fin doit être postérieure à la date de début"
                valid= false;
              }
            } else if (profilId.pivotId !== this.profilActive.pivot_id) {
              if (this.dateFinProfil[this.profilActive.pivot_id] !== "" && this.dateFinProfil[this.profilActive.pivot_id] !== null) {
                let dateToProfilActive = new Date(this.dateFinProfil[this.profilActive.pivot_id])
                if (dateFromProfil.getTime() <= dateToProfilActive.getTime()) {
                  this.errors.dateDebutProfil[profilId.pivotId] = "La date de début du profil ne peut être inférieur à la date de fin du profil actif";
                  valid = false;
                }
              }
              if (this.dateFinProfil[profilId.pivotId] !== null && this.dateFinProfil[profilId.pivotId] !== "") {
                let dateToProfil = new Date(this.dateFinProfil[profilId.pivotId])
                if (dateToProfil.getTime() < dateFromProfil.getTime()) {
                  this.errors.dateFinProfil[profilId.pivotId] = "La date de fin doit être postérieure à la date de début"
                  valid= false;
                }
              } else {
                let nbDateFinVide = 0;
                Object.keys(this.dateFinProfil).forEach( key => {
                  if (isEmpty(this.dateFinProfil[key])) {
                    nbDateFinVide++;
                  }
                });
                // let profilsDateFinVide = this.dateFinProfil.filter((dateFin) => {
                //   return (dateFin === "" || dateFin === null)
                // })
                if (nbDateFinVide > 1) {
                  this.errors.dateFinProfil[profilId.pivotId] = "Il ne peut y avoir plus d'une date de fin non renseignée"
                  valid= false;
                }
              }
            }
          }
        }
        if (valid) {
          valid = this.checkCoherenceDate()
        }
      }
      // console.log('valid',valid)
      // console.log('this.errors.dateFinProfil',this.errors.dateFinProfil)
      return valid;
    },
    checkCoherenceDate() {
      let valid = true
      for(let profilId1 of this.profilsId) {
        for(let profilId2 of this.profilsId) {
          let profilConcerned = this.profils.filter((option) => {
            return option.id === profilId2.profilId
          })
          // console.log(profilConcerned)
          if (profilId1 !== profilId2) {
            if (this.dateFinProfil[profilId2.pivotId] === "" || this.dateFinProfil[profilId2.pivotId] === null) {
              if (this.dateFinProfil[profilId1.pivotId] >= this.dateDebutProfil[profilId2.pivotId]) {
                this.errors.dateFinProfil[profilId1.pivotId] = "La date de fin entre en conflit avec le profil " + profilConcerned[0].text
                valid= false
              }
              if (this.dateDebutProfil[profilId1.pivotId] >= this.dateDebutProfil[profilId2.pivotId]) {
                this.errors.dateDebutProfil[profilId1.pivotId] = "Il faut donner une date de fin au profil " + profilConcerned[0].text + " avant de pouvoir ajouter un profil postérieur"
                valid= false
              }
            } else {
              if (this.dateDebutProfil[profilId1.pivotId] >= this.dateDebutProfil[profilId2.pivotId] && this.dateDebutProfil[profilId1.pivotId] <= this.dateFinProfil[profilId2.pivotId]) {
                this.errors.dateDebutProfil[profilId1.pivotId] = "La date de début entre en conflit avec le profil " + profilConcerned[0].text
                valid= false
              }
              if (this.dateFinProfil[profilId1.pivotId] >= this.dateDebutProfil[profilId2.pivotId] && this.dateFinProfil[profilId1.pivotId] <= this.dateFinProfil[profilId2.pivotId]) {
                this.errors.dateFinProfil[profilId1.pivotId] = "La date de fin entre en conflit avec le profil " + profilConcerned[0].text
                valid= false
              }
            }
          }
        }
      }
      return valid
    },
    clearErrors() {
      this.errors.nom = ""
      this.errors.prenom = ""
      this.errors.email = ""
      this.errors.structure = ""
      this.errors.nsi_numero_user = ""
      this.errors.nsi_numero_acteur = ""
      this.errors.dateDebut = ""
      this.errors.dateFin = ""
      this.errors.selectedProfil = ""
      this.errors.dateDebutProfil = []
      this.errors.dateFinProfil = []
    },
    getStructures() {
      this.$axios
        .get("/administration/structures")
        .then(response => {
          for(let structures of response.data.structures){
            this.structuresOptions.push({value: structures.id, text: structures.libelle})
          }
        })
        .catch(() => {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un probléme est survenue, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    debloquer() {
      let self = this;
      let userId = this.$route.params.id;
      let dataPost = {};

      dataPost.userId = userId;
      this.$axios
        .post('/administration/users/debloquer', dataPost)
        .then(response => {
          this.$swal({
            position: 'top',
            type: 'success',
            title: 'Modification avec succès',
            text: 'L\'utilisateur a bien été débloqué',
            showConfirmButton: false,
            timer: 5000
          });
          this.populateUser();
        })
        .catch(function(error) {
          self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
  }
};
</script>
<style type="text/css">
  .profil-actif .table thead th {
    background-color: #ddf2e6;
  }
  .profil-actif .table-striped tbody tr:nth-of-type(odd) {
    background-color: #effdfa;
  }
</style>
